import React, { lazy } from "react";
import PrivateRoute from "../../components/PrivateRoute";
import { Routes } from "../../context/App";

const ThankYou = lazy(() => import("../../pages/ThankYou"));

interface ThankYouProps {
  route: typeof Routes.THANKYOU;
  path: string;
  exact: boolean;
}

const ThankYouRoute: React.FC<ThankYouProps> = (props) => {
  const { route, path, exact } = props;
  return (
    <PrivateRoute
      path={path}
      route={route}
      exact={exact}
      Component={ThankYou}
    />
  );
};

export default ThankYouRoute;
